<template>
  <!--How the progress bar is displayed changes depending on whether it is in a popup or not-->
  <div
    v-if="inPopup"
    :class="
      smallBar
        ? 'transition-all ease-linear duration-500 transform -translate-y-full progress-bar-container lg:mb-0 mt-0 sticky top-1 z-10'
        : 'transition-all ease-linear duration-500 progress-bar-container mb-8 mt-3 sticky top-0 z-10'
    "
  >
    <div class="flex">
      <div
        v-if="infosPage.progress <= 75"
        :class="
          smallBar
            ? 'progress-bar bg-pink-600 flex-initial h-3 transition-all ease-linear duration-500'
            : 'progress-bar bg-pink-600 flex-initial h-0.5 transition-all ease-linear duration-500'
        "
        :style="'width: ' + infosPage.progress + '%;'"
      />
      <div
        v-else
        :class="
          smallBar
            ? 'progress-bar bg-teal-600 flex-initial h-3 transition-all ease-linear duration-500'
            : 'progress-bar bg-teal-600 flex-initial h-0.5 transition-all ease-linear duration-500'
        "
        :style="'width: ' + infosPage.progress + '%;'"
      />
      <div
        v-if="infosPage.progress >= 75 && !smallBar"
        class="transition-all ease-linear duration-300 flex-none bg-opacity-100 h-12 w-12 rounded-full text-sm text-center border border-teal-600 border-opacity-25 bg-teal-300 text-teal-600 pt-3 -mt-5.5"
      >
        {{ infosPage.progress }}%
      </div>
      <div
        v-else-if="!smallBar"
        class="transition-all ease-linear duration-300 flex-none bg-opacity-100 h-12 w-12 rounded-full text-sm text-center border border-pink-600 border-opacity-25 bg-pink-300 text-pink-600 pt-3 -mt-5.5"
      >
        {{ infosPage.progress }}%
      </div>
      <div
        v-else
        class="transform scale-0 transition-all ease-linear duration-300 flex-none bg-opacity-0 h-0 w-0 rounded-full text-sm text-center border-0 border-pink-600 border-opacity-25 bg-pink-300 text-pink-600"
      >
        {{ infosPage.progress }}%
      </div>
      <div
        :class="
          smallBar
            ? 'transition-all ease-linear duration-500 progress overflow-visible opacity-25 h-3 bg-gray-600 flex-initial mb-5'
            : 'transition-all ease-linear duration-500 progress overflow-visible opacity-25 h-0.5 bg-gray-600 flex-initial mb-5'
        "
        :style="'width: ' + (100 - infosPage.progress) + '%;'"
      />
    </div>
  </div>

  <div
    v-else
    :class="
      smallBar
        ? ' transform -translate-y-full  mb-0 mt-0 top-progress-bar2'
        : 'top-progress-bar mb-12 lg:mb-8'
    "
    id="progressBar"
    class="transition-all ease-linear duration-500 sticky z-10 mt-5 md:mt-0 h-5 md:h-12 pointer-events-none"
  >
    <div class="flex items-center justify-center text-base">
      <div
        v-if="infosPage.progress < infosPage.goal"
        :class="
          smallBar
            ? 'bg-pink-600 flex-initial h-3 transition-all ease-linear duration-500'
            : 'progress-bar bg-pink-600 flex-initial h-0.5 transition-all ease-linear duration-500'
        "
        :style="'width: ' + infosPage.progress + '%;'"
      />
      <div
        v-else
        :class="
          smallBar
            ? 'bg-teal-600 flex-initial h-3 transition-all ease-linear duration-500'
            : 'progress-bar bg-teal-600 flex-initial h-0.5 transition-all ease-linear duration-500'
        "
        :style="'width: ' + infosPage.progress + '%;'"
      />
      <div
        v-if="infosPage.progress >= infosPage.goal && !smallBar"
        class="transition-all ease-linear duration-300 flex-none bg-opacity-100 h-12 w-12 rounded-full text-center flex items-center justify-center border border-teal-600 border-opacity-25 bg-teal-300 text-teal-600"
      >
        {{ infosPage.progress }}%
      </div>
      <div
        v-else-if="!smallBar"
        class="transition-all ease-linear duration-300 flex-none bg-opacity-100 h-12 w-12 rounded-full text-center flex items-center justify-center border border-pink-600 border-opacity-25 bg-pink-300 text-pink-600"
      >
        <p>{{ infosPage.progress }}%</p>
      </div>
      <div
        v-else
        class="transform scale-0 transition-all ease-linear duration-300 bg-opacity-0 h-0 w-0 rounded-full text-center border-0 border-pink-600 border-opacity-25 bg-pink-300 text-pink-600"
      >
        <p>{{ infosPage.progress }}%</p>
      </div>
      <div
        :class="
          smallBar
            ? 'transition-all ease-linear duration-500 opacity-25 h-3 bg-gray-600 flex-initial'
            : 'transition-all ease-linear duration-500 progress overflow-visible opacity-25 h-0.5 bg-gray-600 flex-initial'
        "
        :style="'width: ' + (100 - infosPage.progress) + '%;'"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ProgressBar',
  props: {
    inPopup: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    let typingTimer;
    return {
      smallBar: false,
      doneTypingInterval: 300,
    };
  },

  mounted() {
    if (!this.inPopup) {
      this.initIntersectionObserver();
    }
  },

  computed: {
    ...mapGetters({
      infosPage: 'neopass/infosPage',
    }),
  },

  methods: {
    ...mapMutations({
      calculate_progress: 'neopass/calculate_progress',
    }),

    userKeyDown() {
      //Reset timer on each subsequent input
      clearTimeout(this.typingTimer);
    },

    userKeyUp() {
      //Reset then start timer when user releases key
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(
        this.userDoneTyping,
        this.doneTypingInterval
      );
    },

    userDoneTyping() {
      //Calculate progress only when user hasn't typed in specified amount of time
      this.calculate_progress();
    },

    initIntersectionObserver() {
      //Used to detect when the progress bar intersects with the navbar
      //var rootMargin = this.$isMobile() ? '-100px' : '0px';

      let options = {
        root: document.querySelector('#mainLayout'),
        rootMargin: '0px',
        threshold: 1.0,
      };

      let observer = new IntersectionObserver(this.toggleSmallBar, options);

      let target = document.querySelector('#progressBar');
      observer.observe(target);
    },

    toggleSmallBar(entries, observer) {
      //When it does, make it sticky and small
      if (entries[0].intersectionRatio < 1) {
        this.smallBar = true;
      } else {
        this.smallBar = false;
      }
    },

    reduceProgressBar(event) {
      //Old method still relevant for popups
      if (this.inPopup) {
        let el = event.target;
        this.smallBar = el.scrollTop > 10;
      }
    },
  },
};
</script>

<style>
@media (min-width: 768px) {
  /* more than smartphone */
  .top-progress-bar {
    top: calc(-1.5rem - 1px);
  }

  .top-progress-bar2 {
    top: calc(1.5rem - 1px);
  }
}

@media (max-width: 767px) {
  /*smartphones */
  .top-progress-bar {
    top: calc(-1rem - 1px);
  }

  .top-progress-bar2 {
    top: calc(1rem - 1px);
  }
}
</style>
